import React from 'react';
import { CalendarRange } from './CalendarRange';
import moment from 'moment';

interface ICalendarProps {
  wrapperClass?: string;
  currentDate?: moment.Moment;
  hideClear?: boolean;
  onChange: (date?: moment.Moment) => void;
}

export function Calendar({ wrapperClass, currentDate, onChange, hideClear }: ICalendarProps) {
  return (
    <CalendarRange
      wrapperClass={wrapperClass}
      startDate={currentDate}
      endDate={currentDate}
      selectRange={false}
      hideClear={hideClear}
      onRangeChange={(startDate, endDate) => {
        onChange(startDate);
      }}
    />
  );
}
